import { render, staticRenderFns } from "./CorePurchaseRequest.vue?vue&type=template&id=a1363c8c"
import script from "./CorePurchaseRequest.ts?vue&type=script&lang=ts&external"
export * from "./CorePurchaseRequest.ts?vue&type=script&lang=ts&external"
import style0 from "./CorePurchaseRequest.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports